/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 14:31:51
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-13 15:00:33
 * @FilePath: /dsicm-admin-web/src/api/org.js
 */
//组织机构 医院信息

//引入接口文档
import req from '@/utils/req.js'

//医院数据分页查询
export function api_hospital(params) {
  return req.post('/admin/hospital/search', params)
}

//开放科室数据获取
export function api_open_department_search(params) {
  return req.get('/admin/open-department/search', params)
}

//医院数据列表
export function api_hospital_list(params={}) {
  return req.post('/admin/hospital/list', params)
}
//更新科室禁用状态
export function updateDepartmentDisabledStatus(params) {
  return req.put('/admin/open-department', params)
}
//获取科室分页数据
export function getOpenDepartmentPage(params) {
  return req.get('/admin/open-department/search', params)
}
//删除科室
export function deleteOpenDepartmentPage(id) {
  return req.get('/admin/open-department/search/${id}', params)
}
//获取字典项
export function codechildren(params) {
  return req.get(`/admin/category/${params}/children`)
}

//医院添加
export function addhospital(params) {
  return req.post(`/admin/hospital`, params)
}
//医院更新
export function puthospital(params) {
  return req.put(`/admin/hospital`,params)
}

//平台医院分页查询
export function platform(params) {
  return req.post(`/admin/platform/page`, params)
}
//医院添加
export function addPlatform(params) {
  return req.post(`/admin/platform`, params)
}

//医院修改
export function putPlatform(params) {
  return req.put(`/admin/platform`, params)
}

//平台绑定微信应用列表获取
export function wechatPlatform(params) {
  return req.get(`/admin/wechat-app/type/platform`,params)
}

//关联监管部门
export function getSupervisionList(params) {
  return req.post(`/dsicm-supervision/feign/basic/list`,params)
}

//医院列表查询
export function getHospital(params = {}) {
  return req.post(`/admin/hospital/list`, params)
}

//平台禁用
export function disablePlat(params) {
  return req.post(`/admin/platform/${params}/disable`)
}

//平台启用
export function enablePlat(params) {
  return req.post(`/admin/platform/${params}/enable`)
}

//医院禁用
export function hospitalDisable(params) {
  return req.post(`/admin/hospital/${params}/disable`)
}

//医院启用
export function hospitalEnable(params) {
  return req.post(`/admin/hospital/${params}/enable`)
}

//获取未补全的数量
export function getIncompleteCount(params) {
  return req.get(`/admin/hospital/getIncompleteCount`,params)
}